var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"person",attrs:{"dense":_vm.dense}},[_c('v-list-item-avatar',{attrs:{"size":22}},[_c('img',{attrs:{"alt":_vm.name,"src":_vm.image}})]),_c('v-list-item-content',[(_vm.title)?_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }